/* NOOON AI Representative widget */
(function () {
  'use strict';

  var root = document.querySelector('[data-nrep]');
  var launcher = document.querySelector('[data-nrep-launcher]');
  if (!root || !launcher) return;

  var API = root.getAttribute('data-nrep-endpoint').replace(/\/$/, '');
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();

  var STR = {
    en: {
      title: 'NOOON REPRESENTATIVE',
      placeholder: 'Pieces, orders, shipping',
      send: 'Send',
      hello: 'NOOON representative here. Ask me about our pieces, sizing, shipping, returns, or your order.',
      error: 'Connection issue. Try again, or email info@nooon.online.',
      disclosure: 'AI representative.',
      draftLabel: 'Message to the NOOON team',
      name: 'Name (optional)',
      email: 'Your email',
      draftSend: 'Send to NOOON',
      draftLater: 'Not now',
      sending: 'Sending…',
      sentTo: 'Sent. The team will reply to ',
      emailBad: 'Add a valid email so the team can reply.',
      sendFail: 'Could not send. Email info@nooon.online instead.',
      finishTab: 'Finish sending in the new tab.',
      dismissed: 'Message not sent.'
    },
    es: {
      title: 'REPRESENTANTE NOOON',
      placeholder: 'Prendas, pedidos, envíos',
      send: 'Enviar',
      hello: 'Representante de NOOON. Pregúntame por nuestras prendas, tallas, envíos, devoluciones o tu pedido.',
      error: 'Problema de conexión. Inténtalo de nuevo o escribe a info@nooon.online.',
      disclosure: 'Representante de IA.',
      draftLabel: 'Mensaje para el equipo NOOON',
      name: 'Nombre (opcional)',
      email: 'Tu email',
      draftSend: 'Enviar a NOOON',
      draftLater: 'Ahora no',
      sending: 'Enviando…',
      sentTo: 'Enviado. El equipo te responderá a ',
      emailBad: 'Añade un email válido para que el equipo pueda responderte.',
      sendFail: 'No se pudo enviar. Escribe a info@nooon.online.',
      finishTab: 'Termina el envío en la pestaña nueva.',
      dismissed: 'Mensaje no enviado.'
    }
  };
  var t = STR[LANG] || STR.en;

  /* ── State (survives navigation within the tab) ─────────────────── */
  var store = {
    get: function (k) {
      try { return JSON.parse(sessionStorage.getItem('nrep_' + k)); } catch (e) { return null; }
    },
    set: function (k, v) {
      try { sessionStorage.setItem('nrep_' + k, JSON.stringify(v)); } catch (e) { /* private mode */ }
    }
  };

  /* ── DOM ────────────────────────────────────────────────────────── */
  var panel = document.createElement('div');
  panel.className = 'nrep-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', t.title);
  panel.innerHTML =
    '<div class="nrep-head">' +
    '  <span class="nrep-head__title">' + t.title + '</span>' +
    '  <button type="button" class="nrep-head__close" aria-label="Close">×</button>' +
    '</div>' +
    '<div class="nrep-log" data-nrep-log></div>' +
    '<form class="nrep-form" data-nrep-form>' +
    '  <input class="nrep-input" data-nrep-input type="text" maxlength="1200" placeholder="' + t.placeholder + '" autocomplete="off">' +
    '  <button class="nrep-send" data-nrep-send type="submit">' + t.send + '</button>' +
    '</form>' +
    '<div class="nrep-foot">' + t.disclosure + ' <a href="/pages/contact">info@nooon.online</a></div>';

  root.appendChild(panel);

  var log = panel.querySelector('[data-nrep-log]');
  var form = panel.querySelector('[data-nrep-form]');
  var input = panel.querySelector('[data-nrep-input]');
  var sendBtn = panel.querySelector('[data-nrep-send]');

  function addMsg(kind, text) {
    var el = document.createElement('div');
    el.className = 'nrep-msg nrep-msg--' + kind;
    if (kind === 'rep') {
      el.innerHTML = linkify(text);
    } else {
      el.textContent = text;
    }
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function linkify(text) {
    var safe = text
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    safe = safe.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_m, label, url) {
      return '<a href="' + url + '">' + label + '</a>';
    });
    safe = safe.replace(/(^|[\s(])((https?:\/\/)[^\s)<]+)/g, function (_m, pre, url) {
      return pre + '<a href="' + url + '">' + url.replace(/^https?:\/\//, '') + '</a>';
    });
    safe = safe.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    return safe;
  }

  function restore() {
    var past = store.get('log') || [];
    past.forEach(function (m) {
      if (m.k === 'draft') addDraft(m.d);
      else addMsg(m.k, m.t);
    });
    if (!past.length) addMsg('rep', t.hello);
  }

  function remember(kind, text) {
    var past = store.get('log') || [];
    past.push({ k: kind, t: text });
    store.set('log', past.slice(-40));
  }

  function saveDraft(d) {
    var past = store.get('log') || [];
    var found = false;
    past.forEach(function (m) { if (m.k === 'draft' && m.d.ref === d.ref) { m.d = d; found = true; } });
    if (!found) past.push({ k: 'draft', d: d });
    store.set('log', past.slice(-40));
  }

  /* ── Team message draft (sent through the store's contact form) ─── */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function addDraft(d) {
    // The card speaks the customer's language, which can differ from the site's
    var t = STR[d.lang] || STR[LANG] || STR.en;
    var card = el('div', 'nrep-draft');
    card.appendChild(el('div', 'nrep-draft__label', t.draftLabel));
    log.appendChild(card);

    if (d.state === 'sent' || d.state === 'dismissed' || d.state === 'tab') {
      card.classList.add('nrep-draft--done');
      card.appendChild(el('div', 'nrep-draft__status',
        d.state === 'sent' ? t.sentTo + d.email : d.state === 'tab' ? t.finishTab : t.dismissed));
      log.scrollTop = log.scrollHeight;
      return;
    }

    var body = el('textarea', 'nrep-draft__body');
    body.value = d.body || '';
    body.rows = 5;
    body.maxLength = 2000;
    var name = el('input', 'nrep-draft__field');
    name.type = 'text'; name.placeholder = t.name; name.autocomplete = 'name'; name.value = d.name || '';
    var email = el('input', 'nrep-draft__field');
    email.type = 'email'; email.placeholder = t.email; email.autocomplete = 'email'; email.required = true;
    email.value = d.email || '';
    var note = el('div', 'nrep-draft__note');
    var actions = el('div', 'nrep-draft__actions');
    var later = el('button', 'nrep-draft__later', t.draftLater); later.type = 'button';
    var go = el('button', 'nrep-draft__send', t.draftSend); go.type = 'button';
    actions.appendChild(later); actions.appendChild(go);
    [body, name, email, note, actions].forEach(function (n) { card.appendChild(n); });
    log.scrollTop = log.scrollHeight;

    function keep() {
      d.body = body.value; d.name = name.value; d.email = email.value.trim();
      saveDraft(d);
    }
    [body, name, email].forEach(function (n) { n.addEventListener('input', keep); });

    function finish(state) {
      d.state = state;
      keep();
      card.innerHTML = '';
      card.classList.add('nrep-draft--done');
      card.appendChild(el('div', 'nrep-draft__label', t.draftLabel));
      card.appendChild(el('div', 'nrep-draft__status',
        state === 'sent' ? t.sentTo + d.email : state === 'tab' ? t.finishTab : t.dismissed));
      log.scrollTop = log.scrollHeight;
    }

    later.addEventListener('click', function () { finish('dismissed'); });

    go.addEventListener('click', function () {
      keep();
      if (!email.value.trim() || !email.checkValidity()) {
        note.textContent = t.emailBad;
        email.focus();
        return;
      }
      if (!body.value.trim()) { body.focus(); return; }
      note.textContent = '';
      go.disabled = true; later.disabled = true;
      go.textContent = t.sending;
      submitContact(d).then(function (result) {
        if (result === 'error') {
          go.disabled = false; later.disabled = false;
          go.textContent = t.draftSend;
          note.textContent = t.sendFail;
          return;
        }
        finish(result);
        reportSent(d.ref);
      });
    });
  }

  // Shopify's notification labels each contact[...] field by its key, so the
  // keys are the labels the team reads (always English; the values stay in
  // the customer's language).
  function contactFields(d) {
    var fields = [
      ['form_type', 'contact'],
      ['utf8', '\u2713']
    ];
    if (d.name && d.name.trim()) fields.push(['contact[name]', d.name.trim()]);
    fields.push(
      ['contact[email]', d.email],
      ['contact[Request]', d.subject || 'Message from the NOOON chat'],
      ['contact[Message]', d.body.trim()],
      ['contact[Language]', d.lang === 'es' ? 'Spanish' : 'English'],
      ['contact[Reference]', d.ref + ' (sent from the NOOON chat)']
    );
    return fields;
  }

  // Same endpoint and fields as /pages/contact, so the team gets the usual
  // Shopify "New customer message" email with Reply-To set to the customer.
  function submitContact(d) {
    var fd = new FormData();
    contactFields(d).forEach(function (f) { fd.append(f[0], f[1]); });
    return fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        if (/contact_posted=true/.test(r.url)) return 'sent';
        if (/challenge/.test(r.url)) return openChallengeTab(d);
        return 'error';
      })
      .catch(function () { return 'error'; });
  }

  // Shopify sometimes asks for a human check. A plain form post in a new tab
  // lets the customer complete it there instead of the message being lost.
  function openChallengeTab(d) {
    var f = document.createElement('form');
    f.method = 'post'; f.action = '/contact'; f.target = '_blank'; f.style.display = 'none';
    contactFields(d).forEach(function (pair) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = pair[0]; i.value = pair[1];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
    f.remove();
    return 'tab';
  }

  function reportSent(ref) {
    getToken().then(function (token) {
      return fetch(API + '/api/draft-sent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token, ref: ref })
      });
    }).catch(function () { /* records only; the message already went out */ });
  }

  /* ── Session ────────────────────────────────────────────────────── */
  function getToken() {
    var cached = store.get('tok');
    if (cached && cached.exp > Date.now() / 1000 + 60) {
      return Promise.resolve(cached.v);
    }
    return fetch(API + '/api/session', { method: 'POST' })
      .then(function (r) { if (!r.ok) throw new Error('session'); return r.json(); })
      .then(function (d) {
        store.set('tok', { v: d.token, exp: Date.now() / 1000 + d.expires_in });
        return d.token;
      });
  }

  /* ── Chat ───────────────────────────────────────────────────────── */
  var busy = false;

  function postChat(message) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var killer = ctrl && setTimeout(function () { ctrl.abort(); }, 60000);
    return getToken()
      .then(function (token) {
        return fetch(API + '/api/chat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token, message: message, drafts: true }),
          signal: ctrl ? ctrl.signal : undefined
        });
      })
      .then(function (r) {
        if (r.status === 401) { store.set('tok', null); throw new Error('auth'); }
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.detail || 'chat');
          return d;
        });
      })
      .then(function (d) {
        if (killer) clearTimeout(killer);
        return d;
      }, function (err) {
        if (killer) clearTimeout(killer);
        throw err;
      });
  }

  function send(message) {
    if (busy) return;
    busy = true;
    sendBtn.disabled = true;
    addMsg('user', message);
    remember('user', message);

    var typing = document.createElement('div');
    typing.className = 'nrep-typing';
    log.appendChild(typing);
    log.scrollTop = log.scrollHeight;

    // One silent retry so a brief backend restart never surfaces as an error
    postChat(message)
      .catch(function () {
        return new Promise(function (res) { setTimeout(res, 2500); })
          .then(function () { return postChat(message); });
      })
      .then(function (d) {
        typing.remove();
        addMsg('rep', d.reply);
        remember('rep', d.reply);
        if (d.draft && d.draft.ref) {
          var draft = { ref: d.draft.ref, subject: d.draft.subject, body: d.draft.body, email: d.draft.email || '', name: '', lang: d.draft.lang };
          saveDraft(draft);
          addDraft(draft);
        }
      })
      .catch(function (err) {
        typing.remove();
        var text = (err && err.message && err.message.length > 20) ? err.message : t.error;
        addMsg('sys', text);
      })
      .then(function () {
        busy = false;
        sendBtn.disabled = false;
        input.focus();
      });
  }

  /* ── Wiring ─────────────────────────────────────────────────────── */
  var opened = false;

  function setOpen(open) {
    panel.classList.toggle('nrep-open', open);
    launcher.setAttribute('aria-expanded', String(open));
    store.set('open', open);
    if (open) {
      if (!opened) { restore(); opened = true; }
      input.focus();
    }
  }

  launcher.addEventListener('click', function (e) {
    e.preventDefault();
    setOpen(!panel.classList.contains('nrep-open'));
  });
  panel.querySelector('.nrep-head__close').addEventListener('click', function () { setOpen(false); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = input.value.trim();
    if (!msg) return;
    input.value = '';
    send(msg);
  });

  if (store.get('open')) setOpen(true);
})();
